module.exports = __webpack_public_path__ + "media/images/mypage/btn06-df9db247cd7154a29e2a96d28f3e54e7.gif";